var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6717",
    "data-name": "Rectangle 6717",
    width: 15,
    height: 15,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64753",
    "data-name": "Path 64753",
    d: "M43.132,37.851a4.987,4.987,0,0,0,2.326,2.32.477.477,0,0,0,.471-.036l1.491-1a.471.471,0,0,1,.453-.042l2.792,1.2a.471.471,0,0,1,.286.5,2.863,2.863,0,0,1-2.839,2.5A8.112,8.112,0,0,1,40,35.178a2.863,2.863,0,0,1,2.5-2.839.471.471,0,0,1,.5.286l1.2,2.8a.477.477,0,0,1-.036.447l-1,1.515A.477.477,0,0,0,43.132,37.851Z",
    transform: "translate(-37.884 -30.677)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.64f9a0175b6c77210f5243d86e5e071d.svg";
export { ForwardRef as ReactComponent };